<div class="container">
    <h2 *ngIf="!isNewClient" class="title">עדכון לקוח/ה</h2>
    <h2 *ngIf="isNewClient" class="title">הוספת לקוח/ה חדש</h2>

    <div class="card-title">
        <div class="card-title__item">
            <span class="card-title__text">פרטים אישיים</span>
            <i class="card-title__icon fa-solid fa-user" aria-hidden="true"></i>
        </div>
    </div>

    <div class="card">
        <div class="card__main">
            <section class="card__section section__main">
                <section class="card__section section__background">
                    <img *ngIf="!isNewClient" class="background__image" src="/assets/img/bg-client-edit.svg" />
                    <img *ngIf="isNewClient" class="background__image" src="/assets/img/bg-client-create.svg" />
                </section>

                <section class="card__section section__form form custom-scrollbar" (scroll)="onScrollEvent()">
                    <form #form="ngForm">
                        <section class="form__section">
                            <div
                                class="form__item input-wrapper input-wrapper_with-label"
                                [ngClass]="{
                                    'input-wrapper_error': isInputInvalid(firstName),
                                    'input-wrapper_with-details': isInputInvalid(firstName)
                                }"
                            >
                                <span class="input-label">שם פרטי</span>
                                <input
                                    class="input"
                                    [(ngModel)]="custcard_3.firstName"
                                    name="firstName"
                                    #firstName="ngModel"
                                    type="text"
                                    required
                                    maxlength="30"
                                    pattern="^(?!\s*$).+"
                                    autocomplete="off"
                                />
                                <span
                                    *ngIf="isInputInvalid(firstName) && (firstName.errors.required || firstName.errors.pattern)"
                                    class="input-details"
                                    >חובה להזין שם לקוח</span
                                >
                            </div>

                            <div class="form__item input-wrapper input-wrapper_with-label">
                                <span class="input-label">שם משפחה</span>
                                <input
                                    class="input"
                                    [(ngModel)]="custcard_3.lastName"
                                    name="lastName"
                                    type="text"
                                    maxlength="30"
                                    autocomplete="off"
                                />
                            </div>

                            <div class="form__item input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_select">
                                <span class="input-label">מין</span>
                                <select class="input" [(ngModel)]="custcard_3.sex" name="sex">
                                    <option *ngFor="let gender of sexData" [value]="gender.id">{{ gender.name }}</option>
                                </select>
                            </div>

                            <div
                                class="form__item input-wrapper input-wrapper_with-label"
                                [ngClass]="{
                                    'input-wrapper_error': isInputInvalid(pelephone),
                                    'input-wrapper_with-details': isInputInvalid(pelephone)
                                }"
                            >
                                <span class="input-label">טלפון נייד</span>
                                <input
                                    class="input form__input_type_phone"
                                    [(ngModel)]="custcard_3.pelephone"
                                    name="pelephone"
                                    #pelephone="ngModel"
                                    type="tel"
                                    inputmode="tel"
                                    maxlength="10"
                                    pattern="05[0-9]{8}"
                                    autocomplete="off"
                                    (input)="onPhoneInput('pelephone', $event.target)"
                                />
                                <span *ngIf="isInputInvalid(pelephone) && pelephone.errors.pattern" class="input-details">מספר טלפון לא תקין</span>
                            </div>

                            <div
                                class="form__item input-wrapper input-wrapper_with-label"
                                [ngClass]="{ 'input-wrapper_error': isInputInvalid(phone), 'input-wrapper_with-details': isInputInvalid(phone) }"
                            >
                                <span class="input-label">טלפון נוסף</span>
                                <input
                                    class="input form__input_type_phone"
                                    [(ngModel)]="custcard_3.phone"
                                    name="phone"
                                    #phone="ngModel"
                                    type="tel"
                                    inputmode="tel"
                                    maxlength="10"
                                    pattern="0[0-9]{9}|0[0-9]{8}"
                                    autocomplete="off"
                                    (input)="onPhoneInput('phone', $event.target)"
                                />
                                <span *ngIf="isInputInvalid(phone) && phone.errors.pattern" class="input-details">מספר טלפון לא תקין</span>
                            </div>

                            <div
                                class="form__item input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_datepicker"
                                [ngClass]="{
                                    'input-wrapper_error': isInputInvalid(birthDay),
                                    'input-wrapper_with-details': isInputInvalid(birthDay)
                                }"
                            >
                                <span class="input-label">תאריך לידה</span>
                                <input
                                    class="input"
                                    bsDatepicker
                                    [(appDateMask)]="custcard_3.birthDay"
                                    #datepickerBirthday
                                    [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', adaptivePosition: true, isAnimated: true }"
                                    [maxDate]="maxDate"
                                    [(ngModel)]="custcard_3.birthDay"
                                    #birthDay="ngModel"
                                    name="birthDay"
                                    type="text"
                                    placeholder="בחר"
                                    autocomplete="off"
                                />
                                <span *ngIf="isInputInvalid(birthDay)" class="input-details">בחר את התאריך הנכון</span>
                            </div>

                            <div class="form__item input-wrapper input-wrapper_with-label">
                                <span class="input-label">כתובת</span>
                                <input class="input" [(ngModel)]="custcard_3.address" name="address" type="text" maxlength="100" autocomplete="off" />
                            </div>

                            <div class="form__item input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_button">
                                <span class="input-label">ישוב</span>
                                <input class="input" [(ngModel)]="custcard_3.cityName" name="cityName" (click)="showDynamicScreen(1)" type="button" />
                            </div>

                            <div
                                class="form__item input-wrapper input-wrapper_with-label"
                                [ngClass]="{ 'input-wrapper_error': isInputInvalid(email), 'input-wrapper_with-details': isInputInvalid(email) }"
                            >
                                <span class="input-label">דואר אלקטרוני</span>
                                <input
                                    class="input"
                                    [(ngModel)]="custcard_3.email"
                                    name="email"
                                    #email="ngModel"
                                    type="email"
                                    inputmode="email"
                                    pattern="^(?!.*\.\.)([a-zA-Z0-9_%+\-]+(?:\.[a-zA-Z0-9_%+\-]+)*)@[a-zA-Z0-9\-]+(?:\.[a-zA-Z0-9\-]+)*\.[a-zA-Z]{2,}$"
                                    maxlength="100"
                                    autocomplete="off"
                                />
                                <span *ngIf="isInputInvalid(email) && email.errors.pattern" class="input-details">הזן את המייל הנכון</span>
                            </div>

                            <div class="form__item input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_button">
                                <span class="input-label">מקור הגעה</span>
                                <input
                                    class="input"
                                    [(ngModel)]="custcard_3.sourceName"
                                    name="sourceName"
                                    (click)="showDynamicScreen(4)"
                                    type="button"
                                />
                            </div>

                            <div class="form__item input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_button">
                                <span class="input-label">לקוח ממליץ</span>
                                <input
                                    class="input"
                                    [(ngModel)]="custcard_3.recommenderfl"
                                    name="recommenderfl"
                                    (click)="showDynamicScreen(3)"
                                    type="button"
                                />
                            </div>

                            <div class="form__item input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_select">
                                <span class="input-label">מטפל מועדף</span>
                                <select class="input" [(ngModel)]="custcard_3.saparID" name="saparID">
                                    <option *ngFor="let sapar of saparData" [value]="sapar.saparId">{{ sapar.saparName }}</option>
                                </select>
                            </div>
                        </section>

                        <section class="form__section form__section_categories">
                            <h3 class="section__title">תיוגים</h3>
                            <button class="categories__button" (click)="showDynamicScreen(2)">
                                הוספת תיוג ללקוח/ה
                                <span class="categories__button-icon button button_icon-only button_theme_main">
                                    <i class="fa-solid fa-plus"></i>
                                </span>
                            </button>
                            <div class="categories__tags">
                                <button *ngFor="let item of categoriesArray" class="tag tag_removable" tabindex="-1">
                                    <button class="tag__icon" (click)="openTagRemovingConfirmDialog(item.custCategoryId)">
                                        <i class="fa-solid fa-xmark"></i>
                                    </button>
                                    <span class="tag__text">{{ item.custCategoryName }}</span>
                                </button>
                            </div>
                        </section>

                        <section class="form__section">
                            <h3 class="section__title">מידע נוסף</h3>
                            <div
                                class="form__item input-wrapper input-wrapper_with-label"
                                [ngClass]="{
                                    'input-wrapper_error': isInputInvalid(identicalNum),
                                    'input-wrapper_with-details': isInputInvalid(identicalNum)
                                }"
                            >
                                <span class="input-label">.ת.ז</span>
                                <input
                                    class="input"
                                    [(ngModel)]="custcard_3.identicalNum"
                                    name="identicalNum"
                                    #identicalNum="ngModel"
                                    type="text"
                                    inputmode="numeric"
                                    pattern="[0-9]{9}"
                                    autocomplete="off"
                                />
                                <span *ngIf="isInputInvalid(identicalNum) && identicalNum.errors.pattern" class="input-details">
                                    הזן מספר זיהוי נכון
                                </span>
                            </div>

                            <div class="form__item input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_button">
                                <span class="input-label">עיסוק לקוח</span>
                                <input
                                    class="input"
                                    [(ngModel)]="custcard_3.occupationName"
                                    name="occupationName"
                                    (click)="showDynamicScreen(5)"
                                    type="button"
                                />
                            </div>

                            <div
                                class="form__item input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_datepicker"
                                [ngClass]="{
                                    'input-wrapper_error': isInputInvalid(wedding_Date),
                                    'input-wrapper_with-details': isInputInvalid(wedding_Date)
                                }"
                            >
                                <span class="input-label">יום נישואין</span>
                                <input
                                    class="input"
                                    bsDatepicker
                                    [(appDateMask)]="custcard_3.wedding_Date"
                                    #datepickerWeeding
                                    [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', isAnimated: true, adaptivePosition: true }"
                                    [maxDate]="maxDate"
                                    [(ngModel)]="custcard_3.wedding_Date"
                                    #wedding_Date="ngModel"
                                    name="wedding_Date"
                                    type="text"
                                    placeholder="בחר"
                                    autocomplete="off"
                                />
                                <span *ngIf="isInputInvalid(wedding_Date)" class="input-details">בחר את התאריך הנכון</span>
                            </div>

                            <div
                                class="form__item input-wrapper input-wrapper_with-label"
                                [ngClass]="{
                                    'input-wrapper_error': isInputInvalid(aditionalPhone),
                                    'input-wrapper_with-details': isInputInvalid(aditionalPhone)
                                }"
                            >
                                <span class="input-label">טלפון בית</span>
                                <input
                                    class="input form__input_type_phone"
                                    [(ngModel)]="custcard_3.aditionalPhone"
                                    name="aditionalPhone"
                                    #aditionalPhone="ngModel"
                                    type="tel"
                                    inputmode="tel"
                                    maxlength="10"
                                    pattern="05[0-9]{8}"
                                    autocomplete="off"
                                    (input)="onPhoneInput('aditionalPhone', $event.target)"
                                />
                                <span *ngIf="isInputInvalid(aditionalPhone) && aditionalPhone.errors.pattern" class="input-details">
                                    מספר טלפון לא תכין
                                </span>
                            </div>

                            <div class="form__item form__item_width-2 input-wrapper input-wrapper_with-label">
                                <span class="input-label">סוג שתייה מועדף</span>
                                <input
                                    class="input"
                                    [(ngModel)]="custcard_3.kindDrink"
                                    name="kindDrink"
                                    type="text"
                                    maxlength="150"
                                    autocomplete="off"
                                />
                            </div>

                            <div class="form__item form__item_width-3 input-wrapper input-wrapper_with-label">
                                <span class="input-label">Facebook</span>
                                <input
                                    class="input"
                                    [(ngModel)]="custcard_3.faceBook"
                                    name="faceBook"
                                    type="url"
                                    maxlength="300"
                                    inputmode="url"
                                    autocomplete="off"
                                />
                            </div>

                            <div class="form__item form__item_width-3 input-wrapper input-wrapper_with-label">
                                <span class="input-label">Instagram</span>
                                <input
                                    class="input"
                                    [(ngModel)]="custcard_3.instLink"
                                    name="instLink"
                                    type="url"
                                    maxlength="300"
                                    inputmode="url"
                                    autocomplete="off"
                                />
                            </div>
                        </section>

                        <div class="form__section form__section_footer">
                            <label class="checkbox-label">
                                הודעות ותזכורות נשלחות ללקוח/ה
                                <input class="checkbox" [(ngModel)]="custcard_3.isSendSMS" name="isSendSMS" type="checkbox" />
                                <span class="custom-checkbox"></span>
                            </label>

                            <span *ngIf="custcard_3.isBlockedMarketingMessages" class="form__warning">
                                <i class="fa-solid fa-ban info__warning-icon"></i>
                                הלקוח/ה חסמ/ה קבלת תוכן שיווקי
                            </span>
                        </div>
                    </form>
                </section>
            </section>

            <aside class="card__section section__client">
                <img
                    *ngIf="custcard_3.imagePath && !clientImagePath && config && custcard_3"
                    class="client__image"
                    [src]="getClientImage()"
                    (error)="clearImagePath()"
                    alt="Client image"
                />
                <img
                    *ngIf="!custcard_3.imagePath && !clientImagePath"
                    class="client__image client__image_default"
                    src="/assets/img/client-avatar.png"
                    alt="Client image"
                />
                <img *ngIf="clientImagePath" class="client__image" [src]="clientImagePath" alt="Client image" />

                <div *ngIf="isImageTypeErrorExist" class="client__image-error">סוג תמונה לא חוקי</div>
                <!-- <div *ngIf="isImageSizeErrorExist" class="client__image-error">גודל התמונה צריך להיות פחות מ-400kB</div> -->

                <span class="card__vip fa-solid fa-heart" [ngClass]="{ card__vip_active: isVIPCustomer() }" (click)="toggleVip()"></span>

                <div class="client__buttons-wrapper">
                    <label
                        class="client__button button button_size_small button_with-icon button_theme_gray"
                        [ngClass]="{ 'client__set-button_focused': isImageInputFocused }"
                        [attr.tabindex]="!isImageInputFocused ? 0 : null"
                        (focus)="onImageLabelFocus()"
                    >
                        <input
                            #imageInput
                            class="set-button__input"
                            type="file"
                            accept="image/*"
                            (change)="uploadImage($event)"
                            (focus)="onImageLabelFocus()"
                            (blur)="onImageLabelBlur()"
                        />
                        הוספת תמונה
                        <i class="fa-regular fa-image" aria-hidden="true"></i>
                    </label>

                    <button
                        class="client__button button button_size_small button_with-icon button_theme_gray"
                        [disabled]="!custcard_3.imagePath && !clientImagePath"
                        (click)="openImageRemovingConfirmDialog()"
                    >
                        מחיקת תמונה
                        <i class="fa-regular fa-trash-can" aria-hidden="true"></i>
                    </button>
                </div>
            </aside>
        </div>

        <footer class="card__footer footer">
            <button
                class="footer__button footer__save-button button button_size_small button_theme_main"
                [disabled]="isDataSaving"
                (click)="submitForm(form)"
            >
                שמירה
            </button>
            <button
                class="footer__button footer__exit-button button button_size_small button_theme_gray-line"
                [disabled]="isDataSaving"
                (click)="exitEditing()"
            >
                ביטול
            </button>
        </footer>
    </div>
</div>

<div class="edit__header_mobile">
    <h2 class="header__title"></h2>
    <h2 *ngIf="!isNewClient" class="header__title">עריכת לקוח/ה</h2>
    <h2 *ngIf="isNewClient" class="header__title">הוספת לקוח/ה</h2>

    <button class="header__cross" (click)="exitEditing()" [disabled]="isDataSaving">
        <i class="cross__icon fa-regular fa-xmark"></i>
    </button>
</div>

<p-dialog
    [ngClass]="{ 'custom-dialog': isConfirmDialogVisible }"
    styleClass="modal modal_type_confirm"
    [(visible)]="isConfirmDialogVisible"
    header="שימו לב!"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
>
    <div class="modal__text">{{ confirmDialogText }}</div>
    <div class="modal__footer">
        <button class="button button_size_small button_theme_main" (click)="closeConfirmDialog(true)">צור לקוח חדש</button>
        <button class="button button_size_small button_theme_gray-line" (click)="closeConfirmDialog(false)">בטל</button>
    </div>
</p-dialog>

<p-dialog
    [ngClass]="{ 'custom-dialog': isImageRemovingConfirmDialogVisible }"
    styleClass="modal modal_type_confirm"
    [(visible)]="isImageRemovingConfirmDialogVisible"
    header="שימו לב!"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
>
    <div class="modal__text">האם ברצונך למחוק את התמונה?</div>
    <div class="modal__footer">
        <button class="button button_size_small button_theme_main" (click)="hideImageRemovingConfirmDialog(true)">מחיקה</button>
        <button class="button button_size_small button_theme_gray-line" (click)="hideImageRemovingConfirmDialog(false)">ביטול</button>
    </div>
</p-dialog>

<p-dialog
    [ngClass]="{ 'custom-dialog': isImageRemovingConfirmDialogVisible }"
    styleClass="modal modal_type_confirm"
    [(visible)]="isTagRemovingConfirmDialogVisible"
    header="שימו לב!"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
>
    <div class="modal__text">האם אתם בטוחים במחיקה?</div>
    <div class="modal__footer">
        <button class="button button_size_small button_theme_main" (click)="hideTagRemovingConfirmDialog(true)">מחיקה</button>
        <button class="button button_size_small button_theme_gray-line" (click)="hideTagRemovingConfirmDialog(false)">ביטול</button>
    </div>
</p-dialog>

<div
    appHostListenerBeforeUnload
    (componentHasChangedOutput)="this.componentHasChanged = $event"
    [saveData]="saveData"
    [receivedData]="custcard_3"
></div>

<p-messages class="messages"></p-messages>
